import { useQuery } from '@tanstack/react-query';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
async function fetchFromAPI<T>(endpoint: string): Promise<T> {
    const response = await fetch(endpoint);
    const message = await response.json();
    if (!response.ok) {
        throw new Error(message.message);
    }
    return message;
}

export function getList() {
    return useQuery({
        queryKey: ['fetchFromAPI', 'utilities', 'list'],
        queryFn: () => fetchFromAPI(`/api/utilities/list`),
    });
}

export async function executeScript<T>(
    endpoint: string,
    args: object,
    httpMethod: string = 'GET',
): Promise<T> {
    // Check if any argument is a File object
    const hasFiles = Object.values(args).some((v) => v instanceof File);

    // Normalize http method to uppercase
    const method = httpMethod.toUpperCase();

    if (hasFiles) {
        // Use FormData for file uploads (always POST)
        const formData = new FormData();
        for (const [k, v] of Object.entries(args)) {
            if (v instanceof File) {
                formData.append(k, v);
            } else if (Array.isArray(v)) {
                v.forEach((val) => formData.append(k, val));
            } else if (v !== null && v !== undefined) {
                formData.append(k, v);
            }
        }

        // Send as POST request with FormData
        const response = await fetch(endpoint, {
            method: 'POST',
            body: formData,
            credentials: 'include',
        });
        const message = await response.json();
        if (!response.ok) {
            throw new Error(message.message);
        }
        return message;
    } else {
        // Use URLSearchParams for regular arguments (works for both GET and POST)
        // This avoids CSRF issues by sending data as query parameters
        const params = new URLSearchParams();
        for (const [k, v] of Object.entries(args)) {
            if (Array.isArray(v)) {
                v.forEach((val) => params.append(k, val));
            } else if (v !== null && v !== undefined) {
                params.append(k, v);
            }
        }

        const url: string = `${endpoint}?${params.toString()}`;

        // Use the specified HTTP method but send data as query params
        if (method === 'POST') {
            const response = await fetch(url, {
                method: 'POST',
                credentials: 'include',
            });
            const message = await response.json();
            if (!response.ok) {
                throw new Error(message.message);
            }
            return message;
        } else {
            return await fetchFromAPI(url);
        }
    }
}
